import { useCallback } from 'react';
import { useMutation } from 'src/graphql';
import { SET_SURVEY_DATA } from 'src/graphql/job/mutation';

const useSetSurveyData = () => {
  const [setSurveyData] = useMutation(SET_SURVEY_DATA);

  return useCallback(
    ( jobId, datasheetVersionId, { endDate = null, prizeDrawUrl = null } ) =>
    setSurveyData({
        variables: {
          jobId,
          datasheetVersionId,
          endDate,
          prizeDrawUrl,
        },
      }),
    [],
  );
};
export default useSetSurveyData;
